import Cookies from 'js-cookie'
const state = {
  concentrateMode: false
}

const mutations = {
  switchMode(state) {
    state.concentrateMode = !state.concentrateMode
    if (state.concentrateMode) {
      Cookies.set('concentrateMode', state.concentrateMode)
    } else {
      Cookies.remove('concentrateMode')
    }
  }
}

const actions = {
  triggerMode({ commit }) {
    commit('switchMode')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
